export const DEFAULT_SLIDESHOW_TRANSITION: SpApi.SlideshowTransition = 'fade';

export const SLIDESHOW_TRANSITIONS: SpApi.SlideshowTransition[] = ['fade', 'cut', 'slide', 'zoom'];
